export class vSession {
    public constructor(init?: Partial<vSession>) {Object.assign(this, init);}
    session_id: string;
    // [Write(false)]
    entry_datetime: Date;
    ip: string;
    agent: string;
    is_active: boolean;
    site_id: string;
    session_start: Date;
}

